<template>
  <main role="main" class="py-4">
    <b-container class="py-2">
      <h4 class="mb-3">{{ $t("emailTemplate") }}</h4>
      <div v-if="isLoading" class="py-3 text-center"><b-spinner/></div>
      <b-tabs v-else lazy content-class="mt-3" v-model="tabIndex">
        <b-tab v-for="templateItem of emailTemplates" :key="templateItem.id" :title="templateItem.displayName">
          <b-form @submit.prevent="submitForm(templateItem)">
            <b-form-group>
              <template v-slot:label>{{ $t("emailSubject") }} <span class="text-danger">*</span></template>
              <b-form-input type="text" required minlength="2" maxlength="200" v-model="templateItem.subject"></b-form-input>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>{{ $t("emailContent") }} <span class="text-danger">*</span></template>
              <ckeditor :editor="editor" v-model="templateItem.content" :config="editorConfig"></ckeditor>
            </b-form-group>
            <div v-if="formErrorMsg" class="text-danger mb-4">{{ formErrorMsg }}</div>
            <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as emailTemplateService from "@/service/emailTemplateService";
  import * as utils from "@/service/util";

  @Component
  export default class EmailTemplates extends BaseComponent {

    editor = null;
    editorConfig = {
      toolbar: [
        "heading", "|",
        "undo", "redo", "|",
        "bold", "italic", "underline", "strikethrough", "fontFamily", "fontSize", "fontColor", "fontBackgroundColor", "|",
        "bulletedList", "numberedList", "|", "indent", "outdent", "|",
        "blockquote", "link", "code", "horizontalLine", "|",
        "removeFormat", "sourceEditing"
      ]
    };

    isLoading = true;
    tabIndex = 0;
    emailTemplates = [
      { name: "new_meeting", displayName: this.$t("emailTypeInviteMeeting").toString() },
      { name: "update_meeting", displayName: this.$t("emailTypeUpdateMeeting").toString() },
      { name: "cancel_meeting", displayName: this.$t("emailTypeCancelMeeting").toString() },
    ];

    formErrorMsg = "";
    isSubmitting = false;


    mounted() {
      this.fetchTemplates();
    }

    async fetchTemplates() {
      try {
        this.isLoading = true;
        this.editor = await utils.loadCkeditor();
        const emailTemplates = await emailTemplateService.getAll();

        for (const t of this.emailTemplates) {
          const tt = emailTemplates.find(it => it.name === t.name);
          Object.assign(t, _.pick(tt, ["id", "content", "subject"]));
        }

        this.emailTemplates = utils.jsonClone(this.emailTemplates);

      } catch (e) {
        console.error(e);

      } finally {
        this.isLoading = false;
      }
    }


    async submitForm(templateItem: any) {
      this.formErrorMsg = null;

      if (!templateItem.content) {
        this.formErrorMsg = this.$t("contentCannotBeBlank").toString();
        return;
      }

      try {
        this.isSubmitting = true;

        const data = _.pick(templateItem, ["id", "subject", "content", "name"]);
        await emailTemplateService.updateTemplate(data);

        this.fetchTemplates();
        this.toastSuccessDelay(this.$t("updateEmailTemplateSuccessful").toString());

      } catch (e) {
        this.formErrorMsg = e.response?.data?.message || e.message;
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
